exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".navbar.no-tabs+.content.module[data-v-aaaad532]:not(.legacy-container){margin-top:4.5rem}#layout.embedded[data-v-aaaad532] .content.module{margin-top:0!important}.wrapper.centered[data-v-aaaad532]{width:100%}.main-panel[data-v-aaaad532]{overflow:visible;position:relative;width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-aaaad532","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Layouts/main.vue
// module id = mgtn
// module chunks = 12